export { default } from "./DominantCategoriesModal";
export { default as DominantCategoriesModal } from "./DominantCategoriesModal";



// WEBPACK FOOTER //
// ./src/components/DominantCategoriesModal/index.ts